module.exports = __webpack_public_path__ + "static/8b6612dd3c32dfb4f97463b1f4cc7014e8b5eaa6cef1dd5097582960a55748ea-679393413653938bbd88e0ffec7edaa5.jpeg";